query UserShow($id: ID!) {
  user(id: $id) {
    id
    email
    phone
    firstName
    lastName
    middleName
    displayName
    avatar {
      id
      url(format: SMALL)
    }
    isAdmin
    isSuperAdmin
    isPartner
    isPlatformAdmin
    platformId
    platform {
      id
      title
    }
    currentOrganizationId
    currentOrganization {
      id
      title
    }
    sudoPartnerUrl: sudoUrl(destination: PARTNER)
    sudoSiteUrl: sudoUrl(destination: SITE)
    apiAuthToken
    createdAt
    updatedAt
    deletedAt
    deleted
    registrationUtm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
    lastUtm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
  }
}
